import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard,
  Search,
  Target,
  Camera as Instagram,
  Briefcase as Linkedin,
  MessageSquare,
  Briefcase,
  Star,
  ThumbsUp,
  MessageCircle as Twitter,
  History,
} from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/analyzer",                    label: "Dashboard",           icon: LayoutDashboard, end: true },
  { to: "/analyzer/analysis/new",       label: "New Analysis",        icon: Search },
  { to: "/analyzer/gap-analysis",       label: "General Analysis",    icon: Target },
  { to: "/analyzer/instagram-analysis", label: "Instagram Analysis",  icon: Instagram },
  { to: "/analyzer/linkedin-analysis",  label: "LinkedIn Analysis",   icon: Linkedin },
  { to: "/analyzer/reddit-analysis",    label: "Reddit Analysis",     icon: MessageSquare },
  { to: "/analyzer/glassdoor-analysis", label: "Glassdoor Analysis",  icon: Briefcase },
  { to: "/analyzer/g2-analysis",        label: "G2 Analysis",         icon: Star },
  { to: "/analyzer/trustpilot-analysis",label: "Trustpilot Analysis", icon: ThumbsUp },
  { to: "/analyzer/twitter-analysis",   label: "Twitter Analysis",    icon: Twitter },
  { to: "/analyzer/history",            label: "History",             icon: History },
];

export default function AnalyzerLayout() {
  return (
    <div className="-mx-6 lg:-mx-10 -my-8 lg:-my-10">
      <div className="sticky top-0 z-20 border-b border-white/[0.06] bg-[#09090b]/90 backdrop-blur-xl px-6 lg:px-10">
        <nav className="flex gap-1 overflow-x-auto py-3 no-scrollbar">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`analyzer-tab-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                cn(
                  "flex shrink-0 items-center gap-2 rounded-lg px-3.5 py-2 text-[13px] font-medium transition-all whitespace-nowrap",
                  isActive
                    ? "bg-white/[0.08] text-white border border-indigo-400/40"
                    : "text-white/60 hover:text-white hover:bg-white/[0.04] border border-transparent"
                )
              }
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="text-[#ededed]">
        <Outlet />
      </div>
    </div>
  );
}
